import React from 'react';
import classNames from 'classnames';
import './index.less';
import { Type, FileType, getExt } from './util';
import ABSIcon from '../ABSIcon';

export interface IABSFileTypeTextProps {
  type?: Type;
  className?: string;
  style?: React.CSSProperties;
  onDownload?: () => void;
  onDelete?: (e?: any) => void;
  key?: number;
  size?: string;
  iconSize?: number;
  name: string;
}

export const fileType = FileType;

class ABSFileTypeText extends React.Component<IABSFileTypeTextProps> {
  public static defaultProps = {
    type: 'default',
    iconSize: 22
  };

  renderSize() {
    const { size } = this.props;
    if (!size) {
      return null;
    }
    const unitArr = new Array('B', 'KB', 'MB');
    let index = 0;
    const srcsize = parseFloat(size);
    index = Math.floor(Math.log(srcsize) / Math.log(1024));
    const displaySize = srcsize / Math.pow(1024, index);
    return (
      <p className="abs-file-text-content-desc">
        {displaySize.toFixed(1) + unitArr[index]}
      </p>
    );
  }

  renderDelete() {
    const { onDelete } = this.props;
    if (!onDelete) {
      return null;
    }
    return <ABSIcon size={13} className="abs-file-text-delete" type="circle-close-filled" onClick={e => onDelete(e)} />;
  }
  render() {
    const { type, className, onDownload, key, name, iconSize } = this.props;
    const classes = classNames(`abs-${type}-file-text`, className);
    const extName = getExt(name);
    if (type === 'default') {
      return (
        <div className={classes} key={key} onClick={onDownload}>
          <ABSIcon size={iconSize} className={`abs-file-text-image abs-file-text-image-${extName}`} type={extName} />
          <div className="abs-file-text-content">
            <p className="abs-file-text-content-title">{name}</p>
            {this.renderSize()}
          </div>
          {this.renderDelete()}
        </div>
      );
    }
    return (
      <div className={classes} key={key} onClick={onDownload}>
        <ABSIcon size={22} type={extName} className={`abs-file-text-image abs-file-text-image-${extName}`} />
        <div className="abs-file-text-content-title">{name}</div>
      </div>
    );
  }
}

export default ABSFileTypeText;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSFileTypeText/index.tsx